export default __webpack_public_path__ + "static/media/Savage Death Pantaloons.32ec123e.jpg";